<template>
  <div class="infobox">
    <div class="image">
      <slot name="image" />
    </div>
    <div class="text-content">
      <div class="title">
        <slot name="title" />
      </div>
      <div class="text-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InfoBox",
};
</script>

<style lang="scss" scoped>
.infobox {
  border: 5px solid $brand-blue;
  border-radius: $border-radius-large;
  padding: $spacing-small;

  font-size: 16px;

  width: $container-button-width;
  margin: $spacing-medium auto;

  display: grid;
  grid-template-columns: auto auto;

  @include media("<medium") {
    width: 100%;
  }
}

.text-body {
  :first-child {
    margin-top: 0;
  }

  :last-child {
    margin-bottom: 0;
  }
}

.image {
  margin: 0 $spacing-small 1rem 0;

  &:empty {
    margin: 0;
  }
}

.title {
  font-size: 20px;
  font-weight: $font-bold;

  &:not(:empty) {
    margin-bottom: 1rem;
  }
}
</style>
